import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
export default {
  defaultEntity: {
    country: null,
    state: null,
    city: null,
    courses: '',
    dateFrom: null,
    dateTo: null,

    mondayHas: false,
    mondayFrom: '',
    mondayTo: '',

    tuesdayHas: false,
    tuesdayFrom: '',
    tuesdayTo: '',

    wednesdayHas: false,
    wednesdayFrom: '',
    wednesdayTo: '',

    thursdayHas: false,
    thursdayFrom: '',
    thursdayTo: '',

    fridayHas: false,
    fridayFrom: '',
    fridayTo: '',

    saturdayHas: false,
    saturdayFrom: '',
    saturdayTo: '',

    sundayHas: false,
    sundayFrom: '',
    sundayTo: '',
    timeMode: 1,
    timeTemporary: []
  },
  layout(entity, states, cities, type, course) {
    const {
      getters,
      state
    } = Vue.prototype.store;
    const {
      rules
    } = state.toggle;
    const {
      countryList
    } = state.location;

    const days = [
      {name: $gettext('Monday'), value: 'monday'},
      {name: $gettext('Tuesday'), value: 'tuesday'},
      {name: $gettext('Wednesday'), value: 'wednesday'},
      {name: $gettext('Thursday'), value: 'thursday'},
      {name: $gettext('Friday'), value: 'friday'},
      {name: $gettext('Saturday'), value: 'saturday'},
      {name: $gettext('Sunday'), value: 'sunday'},
    ]

    let dayFields = [];
    let dayAvailable = days
    if((type === "seeker") || (entity.timeMode === 2 && type === "host")) {
      dayAvailable.forEach(day => {
        dayFields = dayFields.concat([
          {
            column: 4,
            label: day.name,
            type: 'checkbox',
            fieldName: `${day.value}Has`,
            key: entity[`${day.value}Has`]
          },
          {
            column: 4,
            type: 'time',
            placeholder: $gettext('From (hh:mm)'),
            fieldName: `${day.value}From`,
          },
          {
            column: 4,
            type: 'time',
            placeholder: $gettext('To (hh:mm)'),
            fieldName: `${day.value}To`
          },
        ])
      })
    }
    return [
      {
        column: 6,
        fieldName: 'country',
        type: 'autocomplete',
        items: countryList,
        itemValue: 'id',
        itemText: 'name',
        placeholder: $gettext('Select country'),
        label: $gettext('Country'),
        rules: [rules.required],
      },
      {
        column: 6,
        fieldName: 'state',
        type: 'autocomplete',
        items: states,
        itemValue: 'id',
        itemText: 'name',
        placeholder: $gettext('Select state/region/province'),
        label: $gettext('State/Region/Province'),
        rules: [rules.required],
      },
      {
        column: 6,
        fieldName: 'city',
        type: 'autocomplete',
        items: cities,
        itemValue: 'id',
        itemText: 'name',
        placeholder: $gettext('Select city'),
        label: $gettext('City'),
      },
      {
        label: $gettext('Which Golf courses are you ready to play ?'),
        column: 12,
        fieldName: 'courses',
        type: 'multiSelect',
        placeholder: $gettext('Select course'),
        rules: [rules.required],
        show: type === "host",
        item: course,
        state: entity.state ? entity.state.id : null,
        action: 'searchCourse',
        multiple: true
      },
      {
        fieldName: 'timeMode',
        type: 'radio',
        column: 12,
        items: [
          {
            id: 1,
            name: $gettext('Select Days'),
          },
          {
            id: 2,
            name: $gettext('Available Permanently'),
          },
        ],
        itemValue: 'id',
        itemText: 'name',
        class: 'radio-col-8 mb-2',
        show: type === "host"
      },
      {
        column: 12,
        fieldName: 'timeTemporary',
        type: 'timeTemporary',
        show: entity.timeMode === 1 && type === "host",
      },
      {
        column: 6,
        show: type === "seeker",
        type: 'empty'
      },
      {
        column: 6,
        fieldName: 'dateFrom',
        type: 'datePicker',
        placeholder: $gettext('Select'),
        rules: [rules.required],
        show: type === "seeker",
        label: $gettext("Date from")
      },
      {
        column: 6,
        fieldName: 'dateTo',
        type: 'datePicker',
        placeholder: $gettext('Select'),
        rules: [rules.required],
        show: type === "seeker",
        label: $gettext("Date to"),
        toDate: "dateFrom"
      },
      ...dayFields
    ];
  }
};